import { Navigate, useRoutes } from 'react-router-dom';
import { ConfirmIdentity } from 'features/identity';
import { GATEKEEPER_APP_URL } from 'config/remotes';
import { RedirectToExternal } from 'react-deep-link';


export const AppRoutes = () => {
  const mfeRoutes = [
    {
      path: '/',
      element: <RedirectToExternal to={GATEKEEPER_APP_URL} replace />,
    },
    { path: '/confirm-identity', element: <ConfirmIdentity /> },
  ];

  const element = useRoutes([...mfeRoutes]);

  return <>{element}</>;
};

export const PAGES = {
  finance: 'finance',
  currencies: 'currencies',
  currencyDetails: 'currency_details',
  paymentMethods: 'payment_methods',
  withdrawPaymentMethods: 'withdraw_payment_methods',
  depositPaymentMethods: 'deposit_payment_methods',
  swapPaymentMethods: 'swap_payment_methods',
  transferPaymentMethods: 'tranfer_payment_methods',
};
